"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colors = exports.Colors = exports.BaseColors = void 0;
exports.randomColor = randomColor;
var colors = exports.colors = {
  //These are legacy colors
  black: '#000',
  red: '#FDA198',
  yellow: '#FFF36D',
  green: '#C7EEC7',
  blue: '#4183D7',
  pink: '#EFB3EE',
  purple: '#9A12B3',
  brown: '#D0BBA9',
  teal: '#FEC99C',
  // actually orange
  grey: '#DEDEDE',
  lightgreen: 'C6FFC7',
  black0: '#000',
  black1: '#FFFFFF',
  black2: '#F2F3F4',
  black3: '#D9DDDF',
  black4: '#8D9091',
  black5: '#424343',
  red0: '#F22613',
  red1: '#FFF5F4',
  red2: '#FEDED8',
  red3: '#FDA198',
  red4: '#F86455',
  red5: '#B50F00',
  orange0: '#F9690E',
  orange1: '#FFF9F5',
  orange2: '#FFECDC',
  orange3: '#FEC99C',
  orange4: '#FB9955',
  orange5: '#CC4F00',
  yellow0: '#FFE400',
  yellow1: '#FFFEF0',
  yellow2: '#FFFBCC',
  yellow3: '#FFF36D',
  yellow4: '#FFED41',
  yellow5: '#DFD000',
  green0: '#00EA70',
  green1: '#F9FDF9',
  green2: '#EBF9EB',
  green3: '#C7EEC7',
  green4: '#63EC9C',
  green5: '#00A950',
  blue0: '#4183D7',
  blue1: '#F3F7FD',
  blue2: '#BDD4F1',
  blue3: '#8DB5E7',
  blue4: '#679CDF',
  blue5: '#004092',
  pink0: '#FF00FF',
  pink1: '#FDF7FD',
  pink2: '#F9E4F9',
  pink3: '#EFB3EE',
  pink4: '#F75AF6',
  pink5: '#D100B8',
  purple0: '#9A12B3',
  purple1: '#FAF3FB',
  purple2: '#DCACE4',
  purple3: '#CC88D9',
  purple4: '#B34DC6',
  purple5: '#6E0C81',
  brown0: '#614126',
  brown1: '#FAF8F6',
  brown2: '#EFE7E1',
  brown3: '#D0BBA9',
  brown4: '#987E68',
  brown5: '#422C19',
  'highlight-none': '#00000'
};
var BaseColors = exports.BaseColors = ['pink', 'green', 'yellow', 'orange', 'brown', 'red', 'black', 'blue', 'purple'];
var Colors = exports.Colors = colors;
function randomColor() {
  var randBaseColorIndex = Math.floor(Math.random() * BaseColors.length);
  var randVariation = Math.floor(Math.random() * 5);
  return colors["".concat(BaseColors[randBaseColorIndex]).concat(randVariation)];
}

//Exporting Colors as this convention (capitalize is predominant in polymer)